module.exports = __webpack_public_path__ + "img/run_pro2.d8887393.webp";